import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from 'src/modules/core/services';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss'],
})
export class SettingComponent implements OnInit {
  permissions: Array<any> = [];

  constructor(private analyticsService: AnalyticsService) {
    this.analyticsService.handleRouteEvents();
  }
  ngOnInit(): void {}
  checkPermission(id: string, action: string): boolean {
    return true;
    // if (this.permissions.filter((res) => res.permissionId === id)[0][action] === 'true') {
    // 	return true;
    // } else {
    // 	return false;
    // }
  }
}
